import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import NavBar from './layout/NavBar'
import Home from './pages/Home'
import BlogList from './components/BlogList'
import BlogPost from './components/BlogPost'

function App() {
  return (
    <Router>
      <div className="page">
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App